// packages/ws-bridge/src/core.ts
import { ALLOWED_BRIDGE_VERSIONS, WSMessage } from "./types";

export function isBridgeMessage(msg: any): msg is WSMessage {
  return (
    msg &&
    (msg.namespace === "WS_BRIDGE" || msg.namespace === "ORG_BRIDGE") &&
    typeof msg.type === "string" &&
    ALLOWED_BRIDGE_VERSIONS.includes(msg.version) &&
    typeof msg.from === "string" &&
    ["workspace", "organization", "app", "admin"].includes(msg.from) &&
    (msg.app_id === undefined || typeof msg.app_id === "number")
  );
}
